package org.example.project.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import org.example.project.PrimaryColor

@Composable
fun AccountInfoSection(iapUnits: Int, orgLicenseUnits: Int) {
    Card(
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(modifier = Modifier.padding(24.dp).fillMaxWidth()) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = "License Overview",
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = Color(0xFF64748B) // Slate 500
                )
            }
            
            Spacer(modifier = Modifier.height(16.dp))

            // Org LicenseUnits (Major)
            Column {
                Text(
                    text = "Enterprise Volume Licenses",
                    style = MaterialTheme.typography.labelMedium,
                    color = Color(0xFF64748B)
                )
                Text(
                    text = "$orgLicenseUnits",
                    style = MaterialTheme.typography.displaySmall,
                    fontWeight = FontWeight.Bold,
                    color = PrimaryColor
                )
                Text(
                    text = "B2B volume licenses allocated to your organization. Can be provisioned to team members or exported as license keys.",
                    style = MaterialTheme.typography.bodySmall,
                    color = Color(0xFF16A34A), // Green 600
                    modifier = Modifier.padding(top = 4.dp)
                )
            }

            Spacer(modifier = Modifier.height(20.dp))
            HorizontalDivider(color = Color(0xFFF1F5F9)) // Slate 100
            Spacer(modifier = Modifier.height(20.dp))

            // IAP Units (Minor)
            Column {
                Text(
                    text = "Personal Licenses (In-App)",
                    style = MaterialTheme.typography.labelMedium,
                    color = Color(0xFF64748B)
                )
                Text(
                    text = "$iapUnits",
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = Color(0xFF334155) // Slate 700
                )
                Text(
                    text = "Purchased directly via Apple In-App Purchase. Non-transferable, tied to your personal account.",
                    style = MaterialTheme.typography.bodySmall,
                    color = Color(0xFF94A3B8), // Slate 400
                    modifier = Modifier.padding(top = 4.dp)
                )
            }
        }
    }
}
